import { graphql } from "@/graphql/codegen/gql"

graphql(`
  query GetApAgingReport($input: ApAgingReportInput!) {
    financialReporting {
      apAgingReport(input: $input) {
        __typename
        ... on ApAgingReportSuccess {
          report {
            summary {
              current
              days1To30
              days31To60
              days61To90
              over90
              total
            }
            vendors {
              vendorCompanyId
              vendorCompany {
                name
                publicId
                externalSystemId
              }
              totals {
                current
                days1To30
                days31To60
                days61To90
                over90
                total
              }
              invoices {
                invoiceId
                invoiceNumber
                invoiceType
                creationDate
                dueDate
                daysOverdue
                agingBucket
                status
                outstandingAmount
              }
            }
            pageInfo {
              total
              offset
              limit
            }
          }
        }
        ... on ApAgingReportFailure {
          error {
            message
          }
        }
      }
    }
  }
`)
